import throttle from '../util/throttle.js';
/**
 * Indent poster on detail page
 */
function $posterify (attrString, callback) {
    attrString = attrString || 'data-js-poster'
    var $poster = $(`[${attrString}]`);


    $poster.each (function () {
        var $this = $(this);

        $this.addClass('is-initilialized');
        checkTitle($this)
    });

    $(window).unbind('resize.poster').bind('resize.poster', throttle(function () {
        $poster.each (function () {
            checkTitle($(this));
        });
    }, 250));

    function checkTitle ($el) {
        var $title = $el.find('[data-js-poster-title]'),
            rows, classStr;

        if ($title) {
            rows = getRows($title);
            if (rows > 4) {
                classStr = 'has-more-lines';
            } else {
                rows = (rows > 0) ? rows : 1;
                classStr = 'has-'+rows+'-lines';
            }
            if (!$el.hasClass(classStr)) {
                $el.removeClass('has-more-lines has-1-lines has-2-lines has-3-lines has-4-lines').addClass(classStr);
            }
        }
    }

    /**
     * Get number text rows in the element
     * @param {jQuery-Element} $el -  The element to count lines in.
     * @returns {int} numberOfRows
     */
    function getRows($el) {
        var height = $el.outerHeight(),
            lineHeight = parseFloat($el.css('line-height')),
            rows = height / lineHeight;
        return Math.round(rows);
    }
}

export default $posterify;


// WEBPACK FOOTER //
// ./src/js/app/components/poster.js